import script from "./confirm_detail.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm_detail.vue?vue&type=script&setup=true&lang=js"

import "./confirm_detail.vue?vue&type=style&index=0&id=2b0af54a&lang=scss"

const __exports__ = script;

export default __exports__